import TreeView, { TreeViewProps } from "./TreeView";
import { TreeNode } from "./types";

export default TreeView;
export type { TreeViewProps, TreeNode };
